<template>
  <div>
    <div class="col-lg-7 col-md-6 offerte-steps-container">
      <h6>{{ translate("in-3-steps-to-your-candycard") }}</h6>
      <div class="offerte-steps">
        <!-- TODO: images be replaced -->
        <div class="offerte-step">
          <img src="/site/img/offert-icon1.png" class="offerte-step__img" />
          <span class="offerte-step__text">
            {{ translate("send-us-your-design") }}
            <br />
            {{ translate("or-layout-wish") }}
          </span>
        </div>
        <div class="offerte-step">
          <img src="/site/img/offert-icon2.png" class="offerte-step__img" />
          <span class="offerte-step__text">
            {{ translate("receive-proof-print") }}
            <br />
            {{ translate("with-quote") }}
          </span>
        </div>
        <div class="offerte-step">
          <img src="/site/img/offert-icon3.png" class="offerte-step__img" />
          <span class="offerte-step__text">
            {{ translate("confirm-proof-print-and") }}
            <br />
            {{ translate("order-chocolate") }}
          </span>
        </div>
      </div>
      <img
        :src="'/storage/offerte-candy-images/' + activeSelection + '.jpg'"
        alt
        class="img-fluid choco-box"
      />
    </div>
    <div class="col-lg-5 col-md-6">
      <div v-if="submitted" class="black_box">
        <h4>{{ translate("Uw aanvraag is verzonden!") }}</h4>
        <p>{{ translate("We nemen zo spoedig mogelijk contact met u op") }}.</p>
      </div>

      <form
        v-else
        action
        ref="form"
        method="POST"
        id="form-section"
        enctype="multipart/form-data"
      >
        <input type="hidden" name="_token" :value="csrfToken" />
        <div class="black_box">
          <h4>{{ translate("Vrijblijvende offerte aanvragen") }}</h4>
          <p>
            {{ translate("U weet over welk product u meer wilt weten?") }}
            <br />
            {{ translate("Stel hier uw offerte samen") }}.
          </p>

          <label>
            <input type="hidden" name="advice-only" value="false" />
            <input type="checkbox" name="advice-only" v-model="hideOfferForm" />
            <div class="checkbox-box"></div>
            <span>{{
              translate("Ik ben er nog niet uit, contact mij voor een advies")
            }}</span>
          </label>

          <div v-show="!hideOfferForm">
            <div class="black_box-section" ref="selection_buttons">
              <h6>{{ translate("Uw product") }}</h6>
              <ul class="black_box-items">
                <li class="black_box-item">
                  <button
                    @click="setActiveSelection('single')"
                    @mouseenter="hoverSelection = 'single'"
                    @mouseleave="hoverSelection = null"
                    :class="{ active: activeSelection === 'single' }"
                    type="button"
                  >
                    <img src="/site/img/mini.png" alt />
                  </button>
                </li>
                <li class="black_box-item">
                  <button
                    @click="setActiveSelection('box-3')"
                    @mouseenter="hoverSelection = 'box-3'"
                    @mouseleave="hoverSelection = null"
                    :class="{ active: activeSelection === 'box-3' }"
                    type="button"
                  >
                    <img src="/site/img/mini-3x.png" alt />
                  </button>
                </li>
                <li class="black_box-item">
                  <button
                    @click="setActiveSelection('box-6')"
                    @mouseenter="hoverSelection = 'box-6'"
                    @mouseleave="hoverSelection = null"
                    :class="{ active: activeSelection === 'box-6' }"
                    type="button"
                  >
                    <img src="/site/img/mini-6x.png" alt />
                  </button>
                </li>
                <li class="black_box-item">
                  <button
                    @click="setActiveSelection('big-box-12')"
                    @mouseenter="hoverSelection = 'big-box-12'"
                    @mouseleave="hoverSelection = null"
                    :class="{ active: activeSelection === 'big-box-12' }"
                    type="button"
                  >
                    <img src="/site/img/6p6.png" alt />
                  </button>
                </li>
                <li class="black_box-item">
                  <button
                    @click="setActiveSelection('maxi-card')"
                    @mouseenter="hoverSelection = 'maxi-card'"
                    @mouseleave="hoverSelection = null"
                    :class="{ active: activeSelection === 'maxi-card' }"
                    type="button"
                  >
                    <img src="/site/img/maxi.png" alt />
                  </button>
                </li>
                <li class="black_box-item">
                  <button
                    @click="setActiveSelection('big-box-maxi-6')"
                    @mouseenter="hoverSelection = 'big-box-maxi-6'"
                    @mouseleave="hoverSelection = null"
                    :class="{ active: activeSelection === 'big-box-maxi-6' }"
                    type="button"
                  >
                    <img src="/site/img/maxi6.png" alt />
                  </button>
                </li>
                <li class="black_box-item">
                  <button
                    @click="setActiveSelection('big-box-maxi-double')"
                    @mouseenter="hoverSelection = 'big-box-maxi-double'"
                    @mouseleave="hoverSelection = null"
                    :class="{
                      active: activeSelection === 'big-box-maxi-double'
                    }"
                    type="button"
                  >
                    <img src="/site/img/maxi2x.png" alt />
                  </button>
                </li>
                <input
                  type="hidden"
                  name="productType"
                  v-model="activeSelection"
                  :required="validateOptionalFields"
                />
              </ul>
            </div>
            <div class="black_box-section">
              <h6>{{ translate("Combinatie") }}</h6>

              <p style="font-size: 18px;">{{ activeOrHoverDescription }}</p>

              <div
                v-for="(combination, combinationKey) in options.combination"
                :key="combinationKey"
              >
                <div class="black_box-block black_box-1-3">
                  <select
                    :required="validateOptionalFields"
                    v-model="formState.combination[combinationKey]"
                    @change="setAmounts()"
                  >
                    <option
                      v-for="(combinationType,
                      combinationTypeKey) in combination"
                      :key="combinationTypeKey"
                      :value="combinationType"
                      >{{ translate(combinationType.name) }}</option
                    >
                  </select>
                  <input
                    type="hidden"
                    name="product[]"
                    :required="validateOptionalFields"
                    v-model="formState.combination[combinationKey].name"
                  />
                </div>
                <div class="black_box-block black_box-1-3">
                  <select name="flavour[]" :required="validateOptionalFields">
                    <option
                      v-for="(productType, productTypeKey) in formState
                        .combination[combinationKey].type"
                      :value="productType"
                      :key="productTypeKey"
                      >{{ translate(productType) }}</option
                    >
                  </select>
                </div>
                <div class="black_box-block black_box-1-3">
                  <select
                    name="weight[]"
                    :required="validateOptionalFields"
                    @change="setAmounts()"
                    ref="weight_input"
                  >
                    <option
                      v-for="(productWeight, productWeightKey) in formState
                        .combination[combinationKey].weight"
                      :value="productWeight"
                      :key="productWeightKey"
                      >{{ translate(productWeight) }}</option
                    >
                  </select>
                </div>
              </div>

              <h6>{{ translate("Verpakking") }}</h6>
              <div class="black_box-block">
                <select
                  name="packaging"
                  :required="validateOptionalFields"
                  @change="setAmounts()"
                  ref="packaging_input"
                >
                  <option
                      :id="'package-option_' + (packagingKey + 1)"
                    v-for="(packaging, packagingKey) in formState.combination[0]
                      .packaging"
                    :value="packaging"
                    :key="packagingKey"
                    >{{ translate(packaging) }}</option
                  >
                </select>
              </div>
            </div>

            <div class="black_box-section">
              <h6>{{ translate("Aantal") }}</h6>
              <div class="black_box-block black_box-half">
                <select name="amount" :required="validateOptionalFields">
                  <option
                    v-for="(amount, amountKey) in amounts"
                    :value="amount"
                    :key="amountKey"
                    >{{ translate(amount) }}</option
                  >
                </select>
              </div>
              <div class="black_box-block black_box-half">
                <input
                  id="file-upload-field"
                  class="file-input"
                  type="file"
                  name="attachments[]"
                  data-multiple-caption="{count} file(s) selected"
                  multiple
                />

                <label for="file-upload-field" class="file-upload">{{
                  translate("BESTANDEN UPLOADEN")
                }}</label>
              </div>
              <div class="black_box-allowtext">jpg, png, pdf, eps, svg, ai</div>
            </div>
          </div>
        </div>
        <div class="delivery-form">
          <h4>{{ translate("Uw gegevens") }}</h4>
          <p>
            {{
              translate(
                "Om de offerte compleet te maken hebben we alleen nog wat contactgegevens nodig"
              )
            }}.
          </p>
          <div class="contact__form-block-wrapper">
            <div class="contact__form-block">
              <input
                :placeholder="translate('Voornaam') + ' *'"
                name="firstname"
                type="text"
                required
              />
            </div>
            <div class="contact__form-block">
              <input
                :placeholder="translate('Achternaam') + ' *'"
                name="lastname"
                type="text"
                required
              />
            </div>
            <div class="contact__form-block">
              <input
                :placeholder="translate('E-mailadres') + '*'"
                name="email"
                type="email"
                required
              />
            </div>
            <div class="contact__form-block">
              <input
                :placeholder="translate('Telefoonnummer') + '*'"
                name="phone"
                type="number"
                required
              />
            </div>
            <span>{{ translate("Optioneel") }}</span>
            <div class="contact__form-block">
              <input
                :placeholder="translate('Bedrijfsnaam')"
                name="company_name"
                type="text"
              />
            </div>
            <div class="contact__form-block">
              <input
                :placeholder="translate('Adres')"
                name="address"
                type="text"
              />
            </div>
            <div class="contact__form-block">
              <input
                :placeholder="translate('Postcode')"
                name="postal_code"
                type="text"
              />
            </div>
            <div class="contact__form-block">
              <input :placeholder="translate('Stad')" name="city" type="text" />
            </div>
            <div class="contact__form-block">
              <input
                :placeholder="translate('Land')"
                name="country"
                type="text"
              />
            </div>
            <div class="contact__form-block">
              <textarea
                cols="30"
                :placeholder="translate('Heeft u nog vragen over dit product?')"
                name="question"
                rows="10"
              ></textarea>
            </div>
          </div>
          <input type="hidden" name="package_description" :value="activeOrHoverDescription">
          <input type="hidden" name="captcha_token" :value="captchaToken">
          <input
            type="button"
            @click="submit"
            class="btn --golden"
            :value="translate('OFFERTE OPVRAGEN')"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import productOptions from "./../offer-form-options";
import { load } from 'recaptcha-v3'
import vSelect from "vue-select";

export default {
  components: {
    "v-select": vSelect
  },

  props: {
    simpleForm: {Boolean, required: false},
    translations: { required: true },
    csrfToken: { required: true },
    submitted: { Boolean, required: true },
    siteKey: {required: true, type: String}
  },

  data: () => ({
    hideOfferForm: false,
    productOptions: productOptions,
    activeSelection: "single",
    hoverSelection: null,
    prefilled: false,
    formState: {
      combination: []
    },
    amounts: [],
    captchaToken: null
  }),

  beforeMount: function() {

    //Toggle the form type
    this.hideOfferForm = !!this.simpleForm;

    this.setDefaultValues();
  },
  mounted: function() {
    this.prepareFileUploadField(document.querySelectorAll(".file-input"));
    this.setAmounts();
    this.setPrefilledSelection();
  },
  methods: {
    getCaptchaToken:function() {
        let self = this;
        load(this.siteKey).then((recaptcha) => {
            recaptcha.execute('offer_form').then((token) => {
                self.captchaToken = token;
                self.$nextTick(() => {
                  self.submit()
                });
            })
        })
    },

    submit: function(){
      if(!this.captchaToken){
        return this.getCaptchaToken();
      }

      this.$refs.form.submit();
    },

    setDefaultValues: function() {
      this.formState.combination = [];
      let key = 0;

      for (let options of this.options.combination) {
        this.formState.combination[key] = options[0];
        key++;
      }
    },
    setActiveSelection: function(selection) {
      this.activeSelection = selection;
      this.setDefaultValues();
      this.setAmounts();
    },
    translate: function(key) {
      if (this.translations[key]) return this.translations[key];

      return key;
    },
    prepareFileUploadField: function(inputs) {
      Array.prototype.forEach.call(inputs, function(input) {
        let label = input.nextElementSibling,
          labelVal = label.innerHTML;

        input.addEventListener("change", function(e) {
          let fileName = "";
          if (this.files && this.files.length > 0)
            fileName = (
              this.getAttribute("data-multiple-caption") || ""
            ).replace("{count}", this.files.length);
          if (fileName) label.innerHTML = fileName;
          else label.innerHTML = labelVal;
        });
      });
    },

    setAmounts: function(combinationKey) {
      // A terrible hack around to make this component work with new requirements
      // A rewrite would be better, but there is no time.
      // Here we can check for exceptions on the rule and alter the selectable amounts

      // I know this is terrible. just.. well..
      const formState = this.formState.combination[0];

      let selectedWeight = this.$refs.weight_input[0].value;
      let selectedPackaging = this.$refs.packaging_input.value;

      // Set the default amounts for this formState
      this.amounts = formState.amounts;

      if (this.activeSelection === "single") {
        // If it's a mini card and selected weight is 10 grams
        if (formState.name == "MiniCard" && selectedWeight == "10gr") {
          this.amounts = [1200, 1800, 3000, 6000, 10200, 20400];
        }

        // If it's a pralinecard and the selected package is blisterbox
        else if (
          formState.name == "Praline" &&
          selectedPackaging == "in Goldblister Box"
        ) {
          this.amounts = [1080, 2160, 3060, 4050, 10080];
        }
      }
    },

    setPrefilledPackageSelection: function(){
        const self = this;
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has("packaging")) return;

        let prefilledPackage = urlParams.get("packaging")

        this.$nextTick(() => {
            let option = document.getElementById('package-option_' + prefilledPackage);

            self.$refs.packaging_input.value = option.value;
        });

    },

    setPrefilledSelection: function() {
      // PREPARE DATA FROM QUERY STRING
      const self = this;
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has("selected")) return;

      let prefilled = urlParams.get("selected").split(",");

      // SET THE CORRECT SELECTED PRODUCT FROM THE FIRST VALUE OF THE QUERYSTRING
      const firstValue = prefilled.shift() - 1; // -1 for it to be zero indexed
      const selectionButtons = this.$refs.selection_buttons.getElementsByTagName(
        "button"
      );
      selectionButtons[firstValue].click();

      // LOOP THROUGH THE COMBINATION OPTIONS TO SET EACH CARD TYPE FROM ON THE VIEW MODEL
      this.$nextTick(() => {
        this.options.combination.forEach((combination, index) => {
          if (!prefilled.length) return;
          const key = prefilled.shift() - 1;
          const selection = combination[key];

          if (selection)
            self.$set(self.formState.combination, index, selection);
        });
      });

      // LOOP THROUGH THE COMBINATION OPTIONS TO SET EACH CHOCOLATE FLAVOUR FROM ON THE VIEW MODEL
      // These don't use data binding
      this.$nextTick(() => {
        const flavourInputs = document.getElementsByName("flavour[]");

        flavourInputs.forEach((input, index) => {
          if (!prefilled.length) return;
          const key = prefilled.shift() - 1;

          // debugger;
          const value = self.formState.combination[index].type[key];

          input.value = value;
        });
      });

      // LOOP THROUGH THE COMBINATION OPTIONS TO SET EACH CHOCOLATE WEIGHT FROM ON THE VIEW MODEL
      // These don't use data binding either
      this.$nextTick(() => {
        const weightInputs = document.getElementsByName("weight[]");

        weightInputs.forEach((input, index) => {
          if (!prefilled.length) return;
          const key = prefilled.shift() - 1;

          // debugger;
          const value = self.formState.combination[index].weight[key];

          input.value = value;
        });
      });


        this.$nextTick(() => {
            this.setPrefilledPackageSelection();
        });

    }
  },
  computed: {
    options: function() {
      return this.productOptions[this.activeSelection];
    },

    validateOptionalFields: function() {
      return !this.hideOfferForm;
    },

    activeOrHoverDescription: function() {
      const selection = this.hoverSelection || this.activeSelection;
      return this.translate(selection + "-description");
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/offer-form-root.vue